import { RangeField } from './range-field.model';

export class StatisticsRequest {
  constructor(
    public year: RangeField,
    public income: RangeField,
    public age: RangeField,
    public states: string[] = [],
    public gender?: 'male' | 'female',
    public groupBy: string[] = [],
    public include: string[] = [],
    public valueType: string | undefined = undefined,
    public categories: string[] | undefined = undefined,
    public subnationalCode?: string,
    public cityIds?: string[],
    public generations?: string[]
  ) {}

  public copy() {
    return new StatisticsRequest(
      this.year,
      this.income,
      this.age,
      this.states.slice(0),
      this.gender,
      this.groupBy.slice(0),
      this.include.slice(0),
      undefined,
      undefined,
      this.subnationalCode
    );
  }
}
